module.exports = __webpack_public_path__ + "static/media/logo.13bfae2e.png";